// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sVRF","content":"styles_content__1BWIZ"};